const style = (theme) => {
  const output = {
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    wrapper: {
      extend: theme.wrapper,
      width: '100%',
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    intro: {
      display: 'flex',
      flexDirection: 'column',
      width: '50%',
    },
    title: {
      color: theme.colors[3],
      fontSize: 39,
      marginBottom: 20,
      lineHeight: 1,
      '& p:last-child': {
        marginBottom: 0,
      },
    },
    text: {
      color: theme.colors[5],
      fontSize: 16,
    },
    grid: {
      width: '100%',
      marginTop: 120,
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    },
    gridItem: {
      display: 'flex',
      flexDirection: 'column',
    },
    gridItemHeader: {
      color: theme.colors[3],
      fontSize: 150,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 20,
      '& svg': {
        width: 120,
        height: 120,
        fill: theme.colors[3],
        marginLeft: 25,
        transform: 'translateY(10px)',
      },
      '& span': {
        lineHeight: 1,
      },
    },
    gridItemFooter: {
      textAlign: 'center',
      textTransform: 'uppercase',
      color: theme.colors[0],
      fontSize: 12,
    },
    btnContainer: {
      marginTop: 50,
      display: 'flex',
      justifyContent: 'center',
    },
  }

  output[theme.mediaInverse.md] = {
    gridItemHeader: {
      fontSize: 100,
    },
  }

  output[theme.mediaInverse.sm] = {
    intro: {
      width: '100%',
    },
    grid: {
      justifyContent: 'center',
      '& > *:not(:last-child)': {
        marginBottom: 30,
      },
    },
  }

  return output
}
export default style
